import { sendMiraklViewBeacon } from '@noths/polaris-client-mirakl-tracking/browser';

import { PUBLIC_API_BASE_PATH } from 'src/constants/environment';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { getMiraklViewEvent } from 'src/tracking/mirakl/getMiraklViewEvent';

/**
 * Posts the view for the listing page in the store to this app's own beacon route, which applies
 * the consent and robot rules. Nothing is sent for a page Mirakl has no identity for.
 */
export const sendMiraklListingViewBeacon = (state: ReduxApplicationState): void => {
  const event = getMiraklViewEvent(state);

  if (event) {
    sendMiraklViewBeacon(PUBLIC_API_BASE_PATH, {
      ...event,
      adUnits: [],
      referer: document.referrer,
      url: window.location.href,
    });
  }
};
